import { FC, Fragment } from "react";
import React from "react";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { NumberInput } from "../core/NumberField";
import { useStyles } from "../../useStyles";
import { Switch } from "../core/Switch";
import { FeedInSystemIcon } from "../core/icons/Icons";
import { BoxedInputWithIconAndOptionalSwitch } from "../core/BoxedInputWithIconAndOptionalSwitch";
import { InputLabel } from "@material-ui/core";

export const ElectricInfeedForm: FC = () => {
    const classes = useStyles();
    const { values, getFieldProps, setValues } =
        useFormModel<ChangeNames.NEW_CONNECTION_ELECTRIC_INFEED>();
    return (
        <Fragment>
            <BoxedInputWithIconAndOptionalSwitch
                icon={<FeedInSystemIcon />}
                content={
                    <Fragment>
                        <p className={classes.label} style={{ marginBottom: 8 }}>
                            Einspeiseanlage
                        </p>
                        <p className={classes.p} style={{ marginTop: 0, marginBottom: 24 }}>
                            Hierzu zählen z. B. Fotovoltaik- und BHKW-Einspeiseanlagen.
                        </p>
                        <p className={classes.p} style={{ marginTop: 0, marginBottom: 24 }}>
                            Sie planen für Ihren Neuanschluss eine Einspeiseanlage? Wunderbar – Für
                            die Dimensionierung Ihres Neuanschlusses tragen Sie bitte unten die
                            Einspeiseleistung ein.
                        </p>
                        <p className={classes.p} style={{ marginTop: 0, marginBottom: 24 }}>
                            Sie möchten Ihre Einspeiseanlage anmelden? Informationen zum
                            Anmeldeverfahren, die Anmeldeformulare und die zur Prüfung
                            einzureichenden Unterlagen entnehmen Sie unter{" "}
                            <a
                                className={classes.p}
                                href="https://www.syna.de/corp/fuer-einspeiser/vorgehensweise-und-anforderungen/anmeldeverfahren"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                www.syna.de
                            </a>
                            .
                        </p>
                    </Fragment>
                }
                useSwitch={
                    <Switch
                        checked={values.newConnectionElectricInfeed.value.installed}
                        {...getFieldProps("newConnectionElectricInfeed.value.installed")}
                        onChange={(e, checked) =>
                            setValues((values) => {
                                values.newConnectionElectricInfeed.value.installed = checked;
                                values.newConnectionElectricInfeed.value.demand.amount = checked
                                    ? 0
                                    : null;
                            })
                        }
                    />
                }
                detailCondition={values.newConnectionElectricInfeed.value.installed}
                detail={
                    <Fragment>
                        <InputLabel className={classes.labledTextfieldLabel}>
                            Summe der Leistung
                        </InputLabel>
                        <NumberInput
                            className={classes.textField}
                            fixedDecimalScale={false}
                            allowLeadingZeros={false}
                            thousandSeparator="."
                            decimalSeparator=","
                            decimalScale={values.newConnectionElectricInfeed.value.demand.precision}
                            isNumericString={false}
                            allowNegative={false}
                            adornment={values.newConnectionElectricInfeed.value.demand.unit}
                            value={values.newConnectionElectricInfeed.value.demand.amount || ""}
                            placeholder="0"
                            onValueChange={(v) =>
                                setValues((values) => {
                                    values.newConnectionElectricInfeed.value.demand.amount =
                                        v.floatValue || null;
                                })
                            }
                            error={values.newConnectionElectricInfeed.error !== null}
                        />
                    </Fragment>
                }
            />
        </Fragment>
    );
};
